// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d11361e","453":"301be211","455":"08d1d71f","977":"5604b62d"}[chunkId] + ".chunk.js";
};